import { Flex, Text, chakra } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { openExternalUrl } from '@/utils/openUrl';
import { getWebAppBaseUrl } from '@/utils/webAppUrl';

/** Log in + forgot password actions for duplicate-email flows (signup form, OAuth callback, volunteer signup). */
export function DuplicateEmailHelpLinks() {
  const navigate = useNavigate();

  // On native, send users to the web forgot-password form (the whole reset
  // flow lives on the web app).
  const handleForgotPassword = () => {
    if (Capacitor.isNativePlatform()) {
      void openExternalUrl(`${getWebAppBaseUrl()}/#/forgot-password`);
    } else {
      navigate('/forgot-password', { replace: true });
    }
  };

  return (
    <Flex direction="column" gap="2" mt="2" align="center">
      <chakra.button
        type="button"
        aria-label="Open login page after duplicate email"
        bg="transparent"
        border="none"
        color="volyx.primary"
        fontSize="sm"
        fontWeight="semibold"
        cursor="pointer"
        p="0"
        _hover={{ opacity: 0.85 }}
        _focus={{ outline: 'none', textDecoration: 'underline' }}
        onClick={() => navigate('/login', { replace: true })}
      >
        Log in
      </chakra.button>
      <Text as="span" fontSize="sm" color="volyx.textSecondary">
        or
      </Text>
      <chakra.button
        type="button"
        aria-label="Open forgot password page"
        bg="transparent"
        border="none"
        color="volyx.primary"
        fontSize="sm"
        fontWeight="semibold"
        cursor="pointer"
        p="0"
        _hover={{ opacity: 0.85 }}
        _focus={{ outline: 'none', textDecoration: 'underline' }}
        onClick={handleForgotPassword}
      >
        Forgot password?
      </chakra.button>
    </Flex>
  );
}
